import { DocumentTab } from "./document-tab-triggers";

export const DOCUMENT_SIDEBAR_GLOBAL_DEFAULT_TAB =
  DocumentTab.TABLE_OF_CONTENTS;

type ResolveDocumentSidebarTabArgs = {
  contextualDefault?: DocumentTab;
  lastUsed: DocumentTab | null;
  availableTabs: DocumentTab[];
};

/**
 * Precedence: contextualDefault → lastUsed → ToC → availableTabs[0]
 */
export const resolveDocumentSidebarTab = ({
  contextualDefault,
  lastUsed,
  availableTabs,
}: ResolveDocumentSidebarTabArgs): DocumentTab => {
  if (contextualDefault && availableTabs.includes(contextualDefault)) {
    return contextualDefault;
  }

  if (lastUsed && availableTabs.includes(lastUsed)) {
    return lastUsed;
  }

  if (availableTabs.includes(DOCUMENT_SIDEBAR_GLOBAL_DEFAULT_TAB)) {
    return DOCUMENT_SIDEBAR_GLOBAL_DEFAULT_TAB;
  }

  return availableTabs[0] ?? DocumentTab.DOCUMENT_METADATA;
};
